import { render, staticRenderFns } from "./actionsManage.vue?vue&type=template&id=1fa94aab"
import script from "./actionsManage.vue?vue&type=script&lang=js"
export * from "./actionsManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports